import { useLanguage } from "@/context/LanguageContext";
import { content } from "@/i18n/content";

const Marquee = () => {
  const { pick } = useLanguage();
  const row = [...content.marquee, ...content.marquee, ...content.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden bg-[#C42021] py-4 md:py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg md:text-2xl tracking-tight text-[#F7F5F0]">
              {pick(item)}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#F7F5F0]/70" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
